import styled from "styled-components";

export const Divider = styled.hr`
    border-color: rgb(126, 58, 242);
`